import request from '@/router/axios'

let urlPrefix = '/api/shenbao/shenbaoevaluate'

export const add = data => {
    return request(`${urlPrefix}`,{
        data: data,
        method:'post'
    })
}


// /shenbaoexpevaluate/query
export const getValuateList = (page, limit, params) => {
    return request(`${urlPrefix}/query`, {
        params: {
            ...params,
            page,
            limit,
        }
    })
}